module.exports = "/images/vendor/lightgallery/src/video-play.png?dc34cc9c99e935cd9c88c036e34103f5";